module.exports = __webpack_public_path__ + "img/photo-1553341640-6b28ff92098a.076e127e.jpg";